// Auth Font-End Model
export interface SocialAuthModel {
    /**Auth id */
    AuthId: string;
    /**Email/Alway null */
    Email: string;
    /**name /Mandatory */
    UserFullName: string;
    /**first_name/Mandatory */
    FirstName: string;
    /**last_name/Mandatory */
    LastName: string;
}

export enum SocialKind { 
    None           = 0,  // not authenticated
    Facebook        = 1,
    Google          = 2, 
}
export interface SocialAuthFontEnd {
    KindId: SocialKind,
    UserInfo: SocialAuthModel |any| null;
}

// check exist db or not.
export interface CustomerSocialModel {
    /**Company Id */
    companyId: number;
    /**Customer PkId */
    Id: number;
    /**Social Identity Id */
    socialId: number;
    /**First Name */
    firstName: string;
    /**Last Name */
    lastName: string;
    /**Customer Email */
    email: string;
    /**Dial Code */
    dialCode: string;
    /**Phone Number */
    phoneNumber: string; 
    /**Create From */
    source: string;
}